import { defineStore } from 'pinia';
import MockResourcesResearch from 'src/mock-data/MockResourcesResearch.json';
import MockMsDrgAnalysis from 'src/mock-data/MockMsDrgAnalysis.json'

export const useResourcesStore = defineStore('resourcesStore', () => {
    function getResourcesResearches(code: string) {
        if (code !== 'D69.9') {
            return MockResourcesResearch['D69.9'];
        } else {
            return MockResourcesResearch.default;
        }
    }

    function getMsDrgAnalysis() {
        return MockMsDrgAnalysis;
    }

    return {
        getResourcesResearches,
        getMsDrgAnalysis
    }
})
